import React from 'react';
import MagnifierIcon from '../../../Icons/MagnifierIcon';
import { Box, Input } from '@coolblue-development/freddy';

interface QuickConnectsSearchProps {
  query: string;
  setQuery: (query: string) => void;
}

const QuickConnectsSearch: React.FC<QuickConnectsSearchProps> = ({ query, setQuery }) => {
  return (
    <Box
      sx={{
        marginTop: '20px',
        marginBottom: '20px',
        position: 'relative',
        border: '1px solid #262930'
      }}
    >
      <Input
        variant="borderless"
        sx={{ width: '100%' }}
        inputSx={{
          backgroundColor: '#1C2027',
          paddingLeft: '40px',
          color: 'white',
          '&:hover': { backgroundColor: '#1C2027' },
          '&:focus-within': { backgroundColor: '#1C2027' },
          '& input::placeholder': { color: '#868A90' }
        }}
        data-testid="quick-connects-search"
        placeholder="Search"
        value={query}
        onChange={e => setQuery(e.target.value)}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '60%',
          transform: 'translateY(-60%)',
          marginLeft: '10px',
          marginRight: '10px'
        }}
      >
        <MagnifierIcon />
      </Box>
    </Box>
  );
};

export default QuickConnectsSearch;
